import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { v4 as uuidv4 } from "uuid";
const AuthModal = ({ setOpen , setValidAuth}) => {
  const [authName, setAuthName] = useState("");
  useEffect(() => {
    setAuthName(`${uuidv4()} Wix account`);
  }, []);

  const AuthHandler = () => {
    window.location.href = "https://www.wix.com/market?appMarketParams=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoie1wiYXBwRGVmSWRcIjpcImM2N2I4MGRlLTQxZWYtNGNmMS04NGM2LTFjNDUwY2YyNDk4MFwiLFwiYXBwdXJpXCI6XCJodHRwOi8vbG9jYWxob3N0OjMwMDAvaW50ZWdyYXRpb24vd2l4XCIsXCJyb3V0ZVwiOlwidGVzdEFwcFwiLFwidmVyc2lvblwiOlwibGF0ZXN0XCJ9IiwiaWF0IjoxNzExNjIwOTU1fQ.YYdwRqf2qixP90kLtwks6L8zCFmmlupxLxPDZ0zbBQ8";
  };

  return (
    <div className="relative">
      <div className="bg-gray-800/30 text-black  w-[100%] min-h-[500px] p-5 absolute inset-0 z-10 ">
        <div className="flex items-center justify-center h-full">
          <div className="bg-white rounded-md p-6 basis-2/3 relative">
            <RxCross2
              className="absolute right-3 hover:cursor-pointer"
              onClick={() => setOpen(false)}
            />
            <h2 className="text-2xl font-semibold my-3 mb-4">
              Create a new authentication
            </h2>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-semibold">
                  Your authentication name
                </label>
                <input
                  type="text"
                  value={authName}
                  className="rounded-md text-sm border-gray-200 text-gray-500"
                  onChange={(e) => setAuthName(e.target.value)}
                />
              </div>
            </div>

            <div className="mt-20 space-x-3 flex justify-end ">
              <button
                className="text-gray-800 rounded-md p-2 px-3 border hover:text-indigo-600 hover:shadow-lg"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
              <button
                onClick={AuthHandler}
                className="text-white rounded-md bg-indigo-600 p-2 px-3 hover:bg-indigo-500"
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
